import { map } from 'rxjs/operators';
import { NameFilter } from './../models/project.model';
import { Company, SubscriptionType } from './../models/company.model';
import { Observable, ReplaySubject } from 'rxjs';
import { CommunicationManagerService } from './communication-manager.service';
import { Injectable } from '@angular/core';
import { head } from 'lodash-es';
import { StubCompany } from '../stubs/company.model';
import { YearlyOverviewMonth } from '../models/yearly-overview-month.model';

@Injectable({ providedIn: 'root' })
export class CompanyService {
  private readonly companyRoute = 'company';
  selectedCompany$ = new ReplaySubject<NameFilter>(1);

  constructor(
    private communicationManagerService: CommunicationManagerService
  ) {}

  private getCompanies() {
    return this.communicationManagerService.get(
      `user/companies`,
      []
    ) as Observable<Company[]>;
  }

  // private getCompaniesFull() {
  //   return this.communicationManagerService.get(
  //     this.companyRoute,
  //     []
  //   ) as Observable<Company[]>;
  // }

  getCompaniesDetailed() {
    return this.getCompanies();
  }

  getCompanyById(companyId: string) {
    return this.communicationManagerService.get(`company`, [
      { headerName: 'companyId', headerValue: companyId },
    ]);
  }

  getCompanyFilters(isAllVisible = false) {
    return this.getCompanies().pipe(
      map((companies) => {
        let mappedCompanies: NameFilter[] = [];
        if (isAllVisible) {
          mappedCompanies.push({
            _id: 'All',
            name: 'All',
          });
        }
        mappedCompanies = mappedCompanies.concat(
          companies.map(
            ({ _id, shortName, sealUrl, baseCurrencyCode }) =>
              ({
                _id: _id,
                name: shortName,
                sealUrl: sealUrl,
                baseCurrencyCode,
              } as NameFilter)
          )
        );
        return mappedCompanies;
      })
    );
  }

  createCompany(company: Company): Observable<Company> {
    return this.communicationManagerService.postAndGetJson(
      this.companyRoute,
      company
    ) as Observable<Company>;
  }

  createAdminCompany(company: Company): Observable<Company> {
    // TODO HANDLE SUBSCRIPTION SIMKE LOSHMI

    const basicCompany = {
      ...StubCompany,
      ...company,
      shortName: company.name,
    };

    delete basicCompany['_id'];
    delete basicCompany['baseCurrency'];
    delete basicCompany['logoUrl'];
    delete basicCompany['createdAt'];
    delete basicCompany['updatedAt'];

    return this.communicationManagerService.postAndGetJson(
      this.companyRoute,
      basicCompany
    ) as Observable<Company>;
  }

  updateCompany(companyId: string, company: Company): Observable<Company> {
    return this.communicationManagerService.put(
      `${this.companyRoute}`,
      company,
      [{ headerName: 'companyId', headerValue: companyId }]
    ) as Observable<Company>;
  }

  uploadSignature(companyId: string, file: File) {
    const payload: FormData = new FormData();
    payload.append('image', file);

    return this.communicationManagerService.uploadFileAndGetJson({
      route: `company/upload/signature`,
      payload: payload,
      addHeaders: [{ headerName: 'companyId', headerValue: companyId }],
    });
  }

  uploadLogo(companyId: string, file: File) {
    const payload: FormData = new FormData();
    payload.append('image', file);

    return this.communicationManagerService.uploadFileAndGetJson({
      route: `company/upload/logo`,
      payload: payload,
      addHeaders: [{ headerName: 'companyId', headerValue: companyId }],
    });
  }
  uploadSeal(companyId: string, file: File) {
    const payload: FormData = new FormData();
    payload.append('image', file);

    return this.communicationManagerService.uploadFileAndGetJson({
      route: `company/upload/seal`,
      payload: payload,
      addHeaders: [{ headerName: 'companyId', headerValue: companyId }],
    });
  }

  getYearlyOverview(companyId: string, year: number) {
    return this.communicationManagerService.get(
      `${this.companyRoute}/overview/yearly/${year}`,
      [{ headerName: 'companyId', headerValue: companyId }]
    ) as Observable<Array<YearlyOverviewMonth>>;
  }

  getCompanyAdditionalInfo(companyId: string) {
    return this.communicationManagerService.get(
      `${this.companyRoute}/additionalInfo`,
      [
        { headerName: 'companyId', headerValue: companyId }
      ]
    );
  }
}
